export * from './battery-manager.component';
